/* eslint-disable no-cond-assign */

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { DataPoints, DataPointResponse } from '../DataPoints';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import RiskPeriods from '@/types/risk-periods';

export default class UpDownDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new UpDownDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return ['UP_DOWN_COLORS'];
  }

  protected build(): void {
    const daoConfig: ProposalNS.UpDownConfig = this.proposalElement.DAO as ProposalNS.UpDownConfig;
    const period: RiskPeriods = daoConfig.period !== undefined ? daoConfig.period : '5Y';

    let itemDAO = null;
    while ((itemDAO = this.nextItem()) !== null) {
      const dpResponse: DataPointResponse<{ up: number; down: number }> = DataPoints.getUpDownMonthsByPeriod(
        itemDAO.item,
        period,
        this.proposal.showBaseCurrencies === true,
      );
      this.addDisclaimerKeys(dpResponse.disclaimerKeys, itemDAO.item);

      const labelUp: string = this.formatMessage('Proposal.Up');
      const fieldUp = new ProposalFieldDAO(labelUp, dpResponse.response.up, ProposalStyleClassNames.ProposalTableContent);
      this.addFieldDAO(itemDAO, fieldUp);
      this.addFieldName(labelUp, ProposalStyleClassNames.ProposalTableContent);

      const labelDown: string = this.formatMessage('Proposal.Down');
      const fieldDown = new ProposalFieldDAO(labelDown, dpResponse.response.down, ProposalStyleClassNames.ProposalTableContent);
      this.addFieldDAO(itemDAO, fieldDown);
      this.addFieldName(labelDown, ProposalStyleClassNames.ProposalTableContent);
    }
  }
}
